import { Component, PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{ fallback: ReactNode }>

export class FetchError extends Component<Props, { hasError: boolean }> {
    public state = { hasError: false };

    public static getDerivedStateFromError(error: unknown) {
        // eslint-disable-next-line no-console
        console.log(error);
        return { hasError: true };
    }

    public render() {
        const { hasError } = this.state;
        const { fallback, children } = this.props;
        if (hasError) {
            // You can render any custom fallback UI
            return fallback;
        }

        return children;
    }
}
